<template>
  <div class="container-view">
    <Breadcrumbs />
    <div class="row col-12">
      <div class="col-12">
        <Listado :dataVerticales="dataVerticales" />
      </div>
    </div>
    <q-page-sticky position="bottom-right" :offset="[28, 28]">
      <q-btn
        data-cy="new-vertical"
        fab
        icon="add"
        title="Crear nuevo vertical"
        color="primary"
        @click="_createVertical()"
      />
    </q-page-sticky>
  </div>
</template>

<script>
import { QPageSticky } from 'quasar';
import Listado from '../components/Listado.vue';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';

export default {
  components: {
    QPageSticky,
    Listado,
    Breadcrumbs
  },
  data: function () {
    return {
      dataVerticales: [],
      isLoading: false
    };
  },
  mounted () {
    this._callData();
  },
  methods: {
    async _callData () {
      this.isLoading = true;

      let request = {
        controller: '/Vertical'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then((response) => {
          this.dataVerticales = response.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.showError(err.message);
          this.isLoading = false;
        });
    },
    _createVertical () {
      this.$router.push({ name: 'form_new_vertical' });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/style.scss";
</style>
